import React from 'react'

import FormTextInput from '../../../components/forms/elements/FormTextInput'

const Content = ({ formDisabled, updateField }) => [
  {
    id: 'refund-user-form-details',
    name: 'Verify details',
    inputs: [
      {
        id: 'email',
        size: 12,
        field: (
          <FormTextInput
            name="email"
            label="Email Address"
            required
            autoComplete="new-email"
            disabled={formDisabled}
            onCut={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => {
              e.preventDefault()
            }}
            onModified={(e) => {
              updateField('email', e.target.value.toUpperCase().trim())
            }}
          />
        ),
      },
      {
        id: 'firstName',
        size: 12,
        field: (
          <FormTextInput
            name="firstName"
            label="First Name"
            required
            autoComplete="new-firstName"
            disabled={formDisabled}
            onModified={(e) => {
              updateField('firstName', e.target.value.toUpperCase())
            }}
          />
        ),
      },
      {
        id: 'lastName',
        size: 12,
        field: (
          <FormTextInput
            name="lastName"
            label="Last Name"
            required
            autoComplete="new-lastName"
            disabled={formDisabled}
            onModified={(e) => {
              updateField('lastName', e.target.value.toUpperCase())
            }}
          />
        ),
      },
    ],
  },
]

export default Content
